import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MyUtils } from 'src/app/services/my-utils.service';


@Component({
  selector: 'app-selected-tab',
  templateUrl: './selected-tab.component.html',
  styleUrls: ['./selected-tab.component.scss']
})
export class SelectedTabComponent implements OnInit, OnChanges {

  @Input() tabList: any 
  @Input() selected?: any;
  @Output() tabSelected = new EventEmitter<string>();
  buttonSelect: any
  constructor( public utils: MyUtils) { }
  ngOnChanges(changes: SimpleChanges): void {

    this.buttonSelect = this.selected ? this.selected :this.tabList[0];
  }

  ngOnInit() {
    this.buttonSelect = this.selected ? this.selected :this.tabList[0];
    
  }


}
